<template>
	<div class="container">
		<h1 class="border-bottom mb-5">Hi {{ sharedState.user.givenName }}!</h1>
		<div class="row">
			<div class="col-md-4">
				<div class="card shadow-sm">
					<div class="card-body">
						<h4 class="card-title mb-4">Your details</h4>
						<dl>
							<dt>ID</dt>
							<dd>{{ sharedState.user.info._id }}</dd>

							<dt>E-mail address</dt>
							<dd>{{ sharedState.user.email }}</dd>

							<dt>Login expires at</dt>
							<dd>{{ expireAt }}</dd>

							<dt>id_token</dt>
							<dd>
								<div class="d-flex">
									<div
										class="text-monospace text-truncate"
										id="id_token"
									>{{ sharedState.user.id_token }}</div>
									<a
										class="ml-2"
										data-clipboard-target="#id_token"
										href="javascript:void(0)"
										title="Copy id_token"
										v-b-tooltip.hover.bottom
									>
										<b-icon icon="clipboard-plus" />
									</a>
								</div>
							</dd>

							<dt>Roles</dt>
							<dd>
								<div class="d-flex">
									<div>(Global)</div>
									<div
										:key="r"
										:title="r"
										v-b-tooltip.hover.bottom
										v-for="r in sharedState.user.info.roles"
									>
										<b-icon
											class="ml-2"
											:icon="icons[r]"
											variant="success"
										/>
									</div>
								</div>
								<div
									class="d-flex"
									:key="g.id"
									v-for="g in groups"
								>
									<div>
										{{ g.name }}
									</div>
									<div
										:key="r"
										:title="r"
										v-b-tooltip.hover.bottom
										v-for="[r] in Object.entries(g.roles).filter(e => e[1])"
									>
										<b-icon
											class="ml-2"
											:icon="icons[r]"
											variant="success"
										/>
									</div>
								</div>
							</dd>
							<div v-if="sharedState.user.info.groups.length > 1">
								<dt>upload group
										<b-icon
											class="ml-2"
											icon="gear"
											@click="changeGroup()"
										/>
								</dt>
								<dd v-if=!change_group>
								{{sharedState.user.info.default_save_to_group_humanized}}
								</dd>
								<dd v-if=change_group>
							<v-select
								v-model="innerValue"
								:options="group_options"
								:label="label"
							/>
								</dd>
							</div>
						</dl>
					</div>
				</div>
			</div>
			<div class="col"></div>
		</div>
		<b-toast
			auto-hide-delay="1500"
			id="id_token_toast"
			no-close-button
			solid
			toaster="b-toaster-top-center"
			variant="success"
		>
			<strong>id_token</strong> copied to clipboard!
		</b-toast>
				<div class="card shadow-sm">
					<div class="card-body">
					<h4 class="card-title mb-4">Last uploads</h4>
				<table class="mb-0 table table-bordered table-hover table-striped table-sm" v-if="sharedState.user.info.latest_upload">
					<thead>
						<tr>
						<th> # </th>
						<th> time </th>
						<th> experiment_id </th>
						<th> animalName </th>
						<th> batch_id </th>
						<th> file_name </th>
						<th> batch_from_date </th>
						<th> batch_till_date </th>
						<th> created </th>
						<th> _id </th>
						<!--<th> measurement_id </th>-->
						</tr>
					</thead>
					<tbody>
						<tr
							v-for="(record,index) in
							sharedState.user.info.latest_upload.slice().reverse()"
							:key="record.upload_time" >
						<td> {{index + 1}} </td>
						<td> {{(new Date(record.upload_time*1000)).toLocaleString("en-ZA")}} </td>
						<td> {{record.experiment_id}} </td>
						<td> {{record.animalName}} </td>
						<td> {{record.batch_id}} </td>
						<td> {{record.file_name}} </td>
						<td> {{record.batch_from_date}} </td>
						<td> {{record.batch_till_date}} </td>
						<td> {{record.batch_created}} </td>
						<td>
							<router-link :to="'/batch/' + record.m_id + '/' + record._id">
							{{ record._id }}
							</router-link>
						</td>
						</tr>
					</tbody>
				</table>
					</div>
				</div>
	</div>
</template>

<script>
import ClipboardJS from 'clipboard'
import icons from '@/icons'
import apiClient from '../apiClient'
import store from '../store'

export default {
	data() {
		return {
			icons,
			change_group: false,
			innerValue: { label: '', id: '' }
		}
	},
	computed: {
		expireAt() {
			const now = new Date().getTime()
			const exp = now + this.sharedState.user.expires_in * 1000
			return new Date(exp).toLocaleTimeString()
		},
		groups() {
			const {
				groups,
				groups_humanized,
				mapping_roles,
			} = this.sharedState.user.info
			const r = []
			for (const id in mapping_roles) {
				const index = groups.indexOf(id)
				const name = groups_humanized[index]
				r.push({
					id,
					name,
					roles: mapping_roles[id],
				})
			}
			return r
		},
		group_options() {
			const {
				groups,
				groups_humanized,
			} = this.sharedState.user.info
			var retval = []
			for (const [index, group] of groups.entries()) {
				retval.push({
					label: groups_humanized[index],
					id: group
				})
			}
			return retval
		}
	},
	methods: {
		async changeGroup() {
			if (this.change_group) {
				var userinfo = await apiClient.userSelfChangeSaveTo(this.innerValue.id)
				store.updateUserInfo(userinfo)
			} else {
				this.innerValue = {
					label: this.sharedState.user.info.default_save_to_group_humanized,
					id: this.sharedState.user.info.default_save_to_group
				}
			}
			this.change_group = !this.change_group
		}
	},
	mounted() {
		const c = new ClipboardJS('#id_token + [data-clipboard-target]')
		c.on('success', (e) => {
			e.clearSelection()
			this.$bvToast.show('id_token_toast')
		})
	},
}
</script>
